import CustomDrawer from "../../../../shared/components/common/CustomDrawer";
import AppText from "../../../../shared/components/common/AppText";
import {GlobalStyleAttributes} from "../../../../shared/styles/GlobalStyles";
import {t} from "../../../../shared/services/i18n";
import {Radio, Tabs} from "antd";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {HStack, VStack} from "native-base";
import FormInput from "../../../../shared/components/common/FormInput";
import AdvanceSelect from "../../../../shared/components/common/AdvanceSelect";
import {Datepicker, locale} from "@mobiscroll/react";
import {useSelector} from "react-redux";
import SharedTimepicker from "../../../../shared/components/common/SharedTimepicker";
import moment from "moment/moment";
import {dbDateFormat, getAccountGroupOptions, isMobile} from "../../../../shared/services/Helpers";
import CustomCheckbox from "../../../../shared/components/common/CustomCheckbox";
import InfoTooltip from "../../../../shared/components/common/InfoTooltip";
import {fetchApi} from "../../../../shared/services/HTTP";
import {flowOptions} from "../../../../shared/components/Structure/Schedule/Popups/CreateEvent/FlowOptions";
import usePermissions from "../../../../shared/services/Permissions";
import {checkRequired} from "../../../../shared/services/stepperService";
import { invoicesTypes, RIVHIT, ARBOX_INVOICES } from "../../../../shared/services/ConstHelper";

const Export = (props) => {
    const {setFieldValue, values, touched, errors, validationSchema, validationObject} = props
    const [locationOptions, setLocationOptions] = useState([])
    const box = useSelector((state) => state.box.box);
    const exportOptions = useMemo(() => {
        return [
            ...(box.rivhit_id == invoicesTypes[RIVHIT] ? [{ value: 2, label: t('rivhit-option') }] : []),
            { value: box.rivhit_id == invoicesTypes[RIVHIT] ? 1 : 2, label: t('hashavshevet-option') },
            { value: 4, label: t('hashavshevet-params-option') },
            ...(box.rivhit_id == invoicesTypes[ARBOX_INVOICES] ? [{ value: 5, label: t('epr-option') }] : []),
        ]
    }, [])
    const hasProjects = useMemo(() => {
        return box.locations_box.some(location => location.project_id !== null)
    }, [box.locations_box])
    const {has} = usePermissions()

    useEffect(() => {
        fetchLocationsByRivhitId()
    }, [])

    const fetchLocationsByRivhitId = async () => {
        const result = getAccountGroupOptions(box?.locations_box);
        setLocationOptions(result)
        if(result?.length === 1) {
            setFieldValue('location_fk', result[0].value?.[0] ?? null)
        }
    }

    const onDateChange = (value) => {
        const date = moment(value)
        const month = date.month()
        const year = date.year()
        setFieldValue('month', month + 1)
        setFieldValue('year', year)
    }

    const onFileTypeChange = (option) => {
        const fileType = option.value ?? null
        setFieldValue('file_type', fileType)
        setFieldValue('journal_entries_mode', fileType === 5 ? 'income_accounts' : 'customer_cards')
    }


    return (
        <VStack space={'1.5rem'}>
            {locationOptions?.length > 1 && <FormInput containerProps={{mb: 0}} label={t('location')+checkRequired('location_fk', validationObject)} width={'100%'}
                        error={(touched?.location_fk && errors?.location_fk) ? errors?.location_fk : null}>
                <AdvanceSelect dontSort options={locationOptions} initValue={values?.location_fk}
                               onChange={(option) => setFieldValue('location_fk', option.value?.[0] ?? null)}
                               isError={touched?.location_fk && errors?.location_fk}/>
            </FormInput>}
            <FormInput containerProps={{ mb: 0 }} label={t('externalSite')} width={'100%'} error={(touched?.file_type && errors?.file_type) ? errors?.file_type : null}>
                <AdvanceSelect dontSort options={exportOptions} 
                               initValue={values?.file_type} onChange={onFileTypeChange} isError={touched?.file_type && errors?.file_type}/>
            </FormInput>
            <FormInput containerProps={{ mb: 0 }} label={t('export-month-label')} width={'100%'} error={(touched?.date && errors?.date) ? errors?.date : null}>
                <SharedTimepicker
                    type={'dates'}
                    dateFormat="MM/YYYY"
                    value={moment(`${values?.month} ${values.year}`, "MM/YYYY")}
                    max={moment()}
                    textStyle={{ fontSize: GlobalStyleAttributes.fonts.standard16 }}
                    onChange={onDateChange}
                    min={moment().subtract(10, 'years').startOf('year')}
                />
            </FormInput>
            {has('viewExportFileDatepicker') &&
                <FormInput containerProps={{ mb: 0 }} label={t('specificDate')} width={'100%'} error={(touched?.reference_date && errors?.reference_date) ? errors?.reference_date : null}>
                    <SharedTimepicker
                        type={'date'}
                        textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}
                        value={values.reference_date}
                        onChange={(value) => setFieldValue('reference_date', moment(value).format(dbDateFormat))}
                        min={moment().subtract(10, 'years').startOf('year')}
                    />
                </FormInput>
            }

            {box.rivhit_id == invoicesTypes[ARBOX_INVOICES] &&<VStack space={'0.3'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('journal-entries-mode')}</AppText>
                <HStack>
                    <Radio.Group value={values.journal_entries_mode} onChange={(e) => setFieldValue('journal_entries_mode', e.target.value)}>
                        <HStack space={'1.2rem'}>
                            <Radio value={'income_accounts'} size="sm" data-testid="export-journal-entries-income">
                                <AppText>{t('journal-entries-direct-income')}</AppText>
                            </Radio>
                            <Radio value={'customer_cards'} size="sm" data-testid="export-journal-entries-customer">
                                <AppText>{t('journal-entries-customer-cards')}</AppText>
                            </Radio>
                        </HStack>
                    </Radio.Group>
                </HStack>
            </VStack>}

            {values.file_type === 5 &&
                <VStack space={'0.3'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('epr-file-type')}</AppText>
                    <HStack>
                        <Radio.Group value={values.epr_file_type} onChange={(e) => setFieldValue('epr_file_type', e.target.value)}>
                            <HStack space={'1.2rem'}>
                                <Radio value={'csv'} size="sm" data-testid="export-epr-csv">
                                    <AppText>{t('epr-csv')}</AppText>
                                </Radio>
                                <Radio value={'xlsx'} size="sm" data-testid="export-epr-xlsx">
                                    <AppText>{t('epr-xlsx')}</AppText>
                                </Radio>
                            </HStack>
                        </Radio.Group>
                    </HStack>
                </VStack>
            }

            <VStack space={'0.3'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('exportTo')}</AppText>
                <HStack>
                    <Radio.Group value={values.export_to} onChange={(e) => {
                        setFieldValue('export_to', e.target.value)
                        if(e.target.value === 'movFile') setFieldValue('email_to', null)
                    }}>
                        <HStack space={'1.2rem'}>
                            <Radio value={'movFile'} size="sm">
                                <AppText>{t('movFile')}</AppText>
                            </Radio>
                            <Radio value={'email'} size="sm">
                                <AppText>{t('export-to-email')}</AppText>
                            </Radio>
                        </HStack>
                    </Radio.Group>
                </HStack>
            </VStack>

            {values.export_to === 'email' &&
                <FormInput
                    label={t('email')}
                    value={values.email_to}
                    validationSchema={validationSchema}
                    name={'email'}
                    onChangeCallback={val => setFieldValue('email_to', val)}
                    error={(touched.email_to && errors.email_to) ? errors.email_to : null}
                    width={'100%'}
                    containerProps={{mb: '0rem'}}
                    type='email'
                />}

            {values.file_type === 1 &&
                <>
                    <FormInput
                        label={t('transactionType')}
                        validationSchema={validationSchema}
                        name={'general_sort'}
                        value={values.general_sort}
                        onChangeCallback={val => setFieldValue('general_sort', val)}
                        width={'100%'}
                        error={(touched.general_sort && errors.general_sort) ? errors.general_sort : null}
                        containerProps={{ mb: '0rem' }}
                    />
                    <FormInput
                        label={t('account')}
                        validationSchema={validationSchema}
                        name={'general_cust'}
                        value={values.general_cust}
                        onChangeCallback={val => setFieldValue('general_cust', val)}
                        width={'100%'}
                        error={(touched.general_cust && errors.general_cust) ? errors.general_cust : null}
                        containerProps={{ mb: '0rem' }}
                    />

                </>
            }

            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('include')}</AppText>
                {values.file_type === 1 &&
                    <>
                        <CustomCheckbox isChecked={values.include_mtc} onChange={val => setFieldValue('include_mtc', val)} text={t('includeMtc')}/>
                        <CustomCheckbox isChecked={values.heshing} onChange={val => setFieldValue('heshing', val)} text={t('heshing')}/>
                    </>
                }
                <CustomCheckbox isChecked={values.new_only} onChange={val => setFieldValue('new_only', val)} text={t('newTransactions')}/>
                {(box.rivhit_id == invoicesTypes[RIVHIT] || box.rivhit_id == invoicesTypes[ARBOX_INVOICES]) && <CustomCheckbox isChecked={values.exclude_deposite} onChange={val => setFieldValue('exclude_deposite', val)} text={t('excludeDeposite')} data-testid="export-exclude-deposite"/>}
                {box.rivhit_id == invoicesTypes[ARBOX_INVOICES] && values.journal_entries_mode === 'customer_cards' && values.file_type !== 5 && <CustomCheckbox isChecked={values.download_customers} onChange={val => setFieldValue('download_customers', val)} text={t('download-customer-files')}/>}
                {box.rivhit_id == invoicesTypes[ARBOX_INVOICES] && <CustomCheckbox isChecked={values.include_payment_reference} onChange={val => setFieldValue('include_payment_reference', val)} text={t('export-payment-reference')} data-testid="export-include-payment-reference"/>}
                {box.rivhit_id == invoicesTypes[ARBOX_INVOICES] && hasProjects && values.file_type === 4 && <CustomCheckbox isChecked={values.export_profit_centers} onChange={val => setFieldValue('export_profit_centers', val)} text={t('export-profit-centers')}/>}
            </VStack>
        </VStack>


    )

}

export default Export